import BaseResource from '@/lib/data/resource/BaseResource'

export default class ResetPasswordResource extends BaseResource {
  constructor (payload = {}) {
    super(payload)

    this.Password = payload.Password ?? null
    this.ConfirmPassword = payload.ConfirmPassword ?? ''
    this.Token = payload.Token ?? this.#urlParam.token ?? ''
  }

  /* PROPERTIES */
  get #urlParam () {
    const urlSearchParams = new URLSearchParams(window.location.search ?? '')
    const params = Object.fromEntries(urlSearchParams.entries())
    return params || {}
  }

  /* METHODS */
}
